const XUGARHERO_ACCESSIBLE_USERS = process.env.API_URL + '/xugarhero/accessibleUsers';

const getAccessibleUsers = (context) => {
  return new Promise((resolve, reject) => {
    context.$http.get(XUGARHERO_ACCESSIBLE_USERS)
      .then(response => {
        const body = response.body;
        const models = body.map(model => { return { id: model.accessibleUserId, label: model.username }; });
        resolve(models);
      }, error => {
        reject(error);
      });
  });
};

export default {
  getAccessibleUsers
};



// WEBPACK FOOTER //
// ./src/brand/xugarhero/api/xugarExplorer/index.js